import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef ,  Input, Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver';
import * as moment from "moment";
import { ImageResult } from 'ngx-image2dataurl';
import { ToastrService } from 'ngx-toastr';
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LocalStorage } from 'ngx-store';

//Model
import { Repair } from './../../../model/maintenance.model';
import { Url } from '../../../model/users.model';
import { ThemeSetting } from '../../../model/users.model';
import { FileExport } from '../../../model/exporter.model';

//Service
import { MaintenanceService} from './../../../services/maintenance.service';
import { FilesService } from './../../../services/files.service';
import { ExportService } from '../../../services/exporter.service';
import { FleetAssetsService } from '../../../services/fleetassets.service';

@Component({
    selector: 'app-repair',
    templateUrl: './repair.component.html',
    styleUrls: ['./repair.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MaintenanceService, FilesService, FleetAssetsService]
  })
  

  export class RepairComponent implements OnInit {
    @LocalStorage() url!: Url;
    @LocalStorage() themeSettings: ThemeSetting;

    public fileStoragePath = this.url.fileStorage;
    public readonly folderPath = this.fileStoragePath + '/repair/';

    repair_rows = [];
    selected = [];
    
    drivers = [];
    fleet = [];
    providers = [];
    showSidebar: boolean = true;

    public repairForm: FormGroup;
    public modalRef: NgbModalRef;

    public repair: Repair;
    public isEditMode: boolean = false;

    public driver_id: any;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    public prefixRepair :string = "repair";
    
    public title : string;
    public objToDelete: any;
    public fileToDelete: string;

    public frmFile: any;
    public fileExists :boolean;
    public fileRemove :boolean;
    public oldFile: string;

    private caller : string ='';
    private modalCaller: string;

    loading_indicator4 : boolean= true;
    public prefix_fleet = "fleetdetails";

    repairsYearly: number;
    repairsMonthly: number;
    repairsWeekly: number;
    repairsRecentCost: number;
    repairsRecentRego: string;
    repairsRecentDate: string;

    summaryCount = 0;
    summaryTotalCost = 0;

    showDate:boolean=true;
    showRego:boolean=true;
    showFleetType:boolean=true;
    showDescription:boolean=true;
    showProvider:boolean=true;
    showCost:boolean=true;
    showReceiptNo:boolean=true;
    showFile:boolean=true;

    totalRepairs: number;
    averageRepairAmount: number;
    totalRepairAmount: number;

    myDropDown='7';
    dateFilter='Last 7 Days';


    public repairDateRange: any =[];
    locale: any = {
      format: 'DD MMMM YYYY',
      displayFormat: 'DD MMMM YYYY',
      separator: ' to ',
      cancelLabel: 'Cancel',
      applyLabel: 'OK',
    }
    maxDate: moment.Moment = moment();

    public exp_excel: FileExport;
    public exp_pdf: FileExport;
    formatted_list : any;
    spinner: boolean = false;

    @Input() repairs: Repair[];
    @Input() parent: string;
    @Input() fleet_id :number; 
    @Output() refreshData : EventEmitter<any>= new EventEmitter<any>();
    @ViewChild('modalRepair', {static: false}) modalRepair: TemplateRef<any>;
    @ViewChild(DaterangepickerDirective, {static: false}) daterangepicker: DaterangepickerDirective;

    constructor(private http: HttpClient, private modal: NgbModal, private _fb: FormBuilder, 
                private maintenanceService: MaintenanceService, private fileService: FilesService,
                private toastr: ToastrService, private fleetAssetsService: FleetAssetsService, private exporter: ExportService){
    }

    ngOnInit() {

      this.initRepairForm();
      this.resetFileVariables();
      this.getRepairs(this.myDropDown);

      this.exp_excel = {title:'', list_data:'', type:''};
      this.exp_pdf = {title:'', list_data:'', type:''};
    }

    repair_columns = [
      { prop: 'Date' },
      { prop: 'Rego' },
      { prop: 'fleet_type' },
      { prop: 'Cost' },
      { prop: 'File' },

    ];

    initRepairForm() {
      const intRegex = '^[0-9]{1,11}$';
      const currencyRegex = '^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
      const numbers = '^[0-9]+$'; 
      this.repairForm = this._fb.group({
        id: [''],
        date_done: ['', Validators.required],
        time_done: [''],
        time_string: [{hour: 1, minute: 30}],
        fleet_id: ['', Validators.required],
        driver_id: ['', Validators.required],
        fleet_report_id: [''],
        provider_id: ['', Validators.required],
        incident_id: [''],
        repair_description: ['', Validators.required],
        receipt_no: ['', Validators.required],
        cost: ['', [Validators.required, Validators.pattern(currencyRegex)]],
        mileage: ['', [Validators.required, Validators.pattern(numbers)]],
        hours:  ['', Validators.pattern(numbers)],
        fault: ['', Validators.required,],
        file: [''],
        note: [''],
        repair_request_id:[''],
      });
    }

    isCost() {
      const frmCtrl = (<any>this.repairForm);
  
      if (frmCtrl.controls.cost.valid)
        return true;
      else return false;
    }
    isMileage() {
      const frmCtrl = (<any>this.repairForm);
  
      if (frmCtrl.controls.mileage.valid)
        return true;
      else return false;
    }
    isHours() {
      const frmCtrl = (<any>this.repairForm);
  
      if (frmCtrl.controls.hours.valid)
        return true;
      else return false;
    }

    onSelect({ selected }) {

    }

    getRepairs(myDropdown,start='', end='') {
      if (this.fleet_id) {
          this.maintenanceService.getRepairsByFleetId(this.fleet_id.toString(),myDropdown,start,end).toPromise().then(data => {
            console.log('DATA USING FLEET_ID');
              this.repair_rows = data["repairs"];
              this.fullRowsRepairs = this.repair_rows;
              this.tempRepairs = this.repair_rows;
              if (typeof this.repair_rows != "undefined"  && this.repair_rows != null  
              && this.repair_rows.length != null  && this.repair_rows.length > 0) {
                  this.selected = [this.repair_rows[0]];
                  this.repairCount = Object.keys(this.repair_rows).length;
              }  
            else{
                this.selected = [];
              }
              this.computeRepairSubtotal();
              setTimeout(() => {  }, 1500);      
          });
          
      }
      else {
          this.maintenanceService.getRepairs(myDropdown,start, end).toPromise().then(data => {
          
              this.repair_rows = data["repairs"];        
              this.fullRowsRepairs = this.repair_rows;
              this.tempRepairs = this.repair_rows;
              if (typeof this.repair_rows != "undefined"  && this.repair_rows != null  
              && this.repair_rows.length != null  && this.repair_rows.length > 0) {
                  this.selected = [this.repair_rows[0]];
                  this.repairCount = Object.keys(this.repair_rows).length;  
              }  
            else{
                this.selected = [];
              }
              this.computeRepairSubtotal()
              setTimeout(() => {  }, 1500);
          });
      }
        this.http.get(this.url.rest + '/tms/getMaintenanceMisc').subscribe(data => {
            this.drivers = data["drivers"];
            this.fleet = data["fleet"];
            setTimeout(() => { this.loading_indicator4 = false; }, 1000);
        });

        this.fleetAssetsService.getProvidersRepairsServices().subscribe(data =>{
          this.providers = data['providers'];
        });

        this.getRepairsSummary();

    }

    getRepairsSummary(){

      if (this.fleet_id) {
        this.maintenanceService.getRepairsSummaryByFleetId(this.fleet_id).subscribe(data => {
          this.repairsYearly = data['repairs_yearly'];
          this.repairsMonthly = data['repairs_monthly'];
          this.repairsWeekly = data['repairs_weekly'];
          this.repairsRecentCost = data['repairs_recent_cost'];
          if( data['repairs_recent_rego'] !== null){
            this.repairsRecentRego = data['repairs_recent_rego']['fleet_id_num'] + '(' + data['repairs_recent_rego']['rego']  + ')';
          }else{ this.repairsRecentRego = '-';};
          this.repairsRecentDate = data['repairs_recent_date'];
        });
      }else{
        this.maintenanceService.getRepairsSummary().subscribe(data => {
          this.repairsYearly = data['repairs_yearly'];
          this.repairsMonthly = data['repairs_monthly'];
          this.repairsWeekly = data['repairs_weekly'];
          this.repairsRecentCost = data['repairs_recent_cost'];
          if( data['repairs_recent_rego'] !== null){
            this.repairsRecentRego = data['repairs_recent_rego']['fleet_id_num'] + '(' + data['repairs_recent_rego']['rego']  + ')';
          }else{ this.repairsRecentRego = '-';};
          this.repairsRecentDate = data['repairs_recent_date'];
        });
      }  
    }

    onChangeofOptions(selected) {
      console.log('changing to', selected);
      if (selected == 'week') {
          this.myDropDown =  'week'
          this.dateFilter = 'This Week'
          this.showFilters = false;
          this.getRepairs(this.myDropDown);
      }
      else
      if (selected == 'month') {
          this.myDropDown =  'month'
          this.dateFilter = 'Month'
          this.showFilters = false;
          this.getRepairs(this.myDropDown);
      }
      else 
      if (selected == 'year') {
          this.myDropDown =  'year'
          this.dateFilter = 'This Year'
          this.showFilters = false;
          this.getRepairs(this.myDropDown);
      }
      else
      if (selected == 'today') {
          this.myDropDown =  'today'
          this.dateFilter = 'Today'
          this.showFilters = false;
          this.getRepairs(this.myDropDown);
      }
      else
      if (selected == '7') {
          this.myDropDown =  '7'
          this.dateFilter = 'Last 7 Days'
          this.showFilters = false;
          this.getRepairs(this.myDropDown);
      }
      else
      if (selected == '14') {
          this.myDropDown =  '14'
          this.dateFilter = 'Last 14 Days'
          this.showFilters = false;
          this.getRepairs(this.myDropDown);
      }
      else
      if (selected == '30') {
          this.myDropDown =  '30'
          this.dateFilter='Last 30 Days'
          this.showFilters = false;
          this.getRepairs(this.myDropDown);
      }
      else
      if (selected == '90') {
          this.myDropDown =  '90'
          this.dateFilter = 'Last 90 Days'
          this.showFilters = false;
          this.getRepairs(this.myDropDown);
      }
      else
      if (selected == 'range') {
          this.myDropDown =  'range'
          this.dateFilter = 'range'
          this.showFilters = true;
          // this.getRepairs(this.myDropDown);
          this.processRepairDateRange('');
      }
      else if(selected == 'all'){
        this.showFilters = true;
        this.getRepairs("");
      }
    }

    processRepairDateRange(event) {
      console.log('processing range');
      // if (event.start != undefined && event.end != undefined){
        var start = moment(this.repairDateRange.start?._d).format('YYYY-MM-DD');
        var end = moment(this.repairDateRange.end?._d).format('YYYY-MM-DD');
      console.log(start + ' to ' + end);
      this.getRepairs('range',start, end);
      // }
    }

    computeRepairSubtotal() {
      this.totalRepairs = 0;
      this.averageRepairAmount = 0;
      this.totalRepairAmount = 0;

      if (this.repair_rows[0]) {
          let sum: number = this.repair_rows.map(a => a.cost).reduce(function(a, b)
          {
          return a + b;
          });
          this.totalRepairAmount = sum;

          this.totalRepairs = this.repair_rows.length;
      }
      this.averageRepairAmount = (this.totalRepairAmount / this.totalRepairs) || 0;
    }

    public createRepair(repair: Repair) {
      this.spinner = true;
        this.maintenanceService.createRepair(repair).toPromise().then(res => {
        this.getRepairs(this.myDropDown);   
        });
        this.spinner = false;
    }
  
    public updateRepair(repair: Repair) {
      this.spinner = true;
        this.maintenanceService.updateRepair(repair).subscribe(ticket => {
        this.getRepairs(this.myDropDown);  
        });
        this.spinner = false;
    }
  
    public deleteRepair(id: number) {
      this.spinner = true;
        this.maintenanceService.deleteRepair(id).subscribe(repair => {
          this.getRepairs(this.myDropDown);  
        });
        this.modalRef.close();   
        this.refreshData.emit(); 
        this.spinner = false;      
    }
    
    openRepairModal(repair: Repair): void {
      
      if(repair) {
        this.isEditMode = true;
        this.repair = repair;
        this.repair['time_string'] = {hour: this.repair['hour'], minute: this.repair['minute']};
        this.repairForm.patchValue(this.repair);

        if (this.repair.file !== null && this.repair.file !== '')
          {
            this.oldFile = this.repair.file;
            this.fileExists = true;
          };
      } 
      else{
        this.isEditMode = false;
        this.repair = new Repair();
        this.repairForm.reset();

        //fleet_id is preset if come from fleetdetails component
        var fleet_value = '';
        if(this.fleet_id){fleet_value = this.fleet_id.toString();};
        this.repairForm.controls.fleet_id.setValue(fleet_value);
        
      }           

      this.modalRef = this.modal.open(this.modalRepair, { size: 'lg', backdrop: 'static'});
    
      this.modalRef.result.then((result) => {
        this.repairForm.reset();
      }, (reason) => {
        this.repairForm.reset();
      });
    }

    verifyDateValuesRepair(){
      if( (this.repairForm.value.date_done != "" && !moment(this.repairForm.value.date_done, "YYYY-MM-DD", true).isValid()) 
      ){
          return false;
      }
      else return true;
    }

    showInvalidDateToastr(){
      this.toastr.error('', 'Entered an invalid date!', {
        timeOut: 2000,
        positionClass: 'toast-top-full-width',
        progressBar: true
    });
    }
  
    async onSubmitRepair(repair: Repair){
      if(this.verifyDateValuesRepair()){
        this.spinner = true;
        this.repair = repair;
        if(this.repair['time_string'] != null){
          this.repair['time_done'] = this.repair['time_string'].hour + ":" + this.repair['time_string'].minute + ":00";
        }else{
          this.repair['time_done'] = '00:00:00'
        }
        if (this.repair['hours'] == null){
          this.repair['hours'] = 0
        }
      
        if (this.repairForm.valid) {
          if(repair.id){
      
        await this.maintenanceService.updateRepair(repair).toPromise().then(res => {
                this.toastr.success('', res["message"], {
                  timeOut: 5000,
                  positionClass: 'toast-top-full-width',
                  progressBar: true
                  });
            }).catch(err =>{
              this.toastr.error("Please try again.", "There was a problem with updating the selected repair record", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
            });
            console.log('updating repair...');
          }else{
            
          await this.maintenanceService.createRepair(repair).toPromise().then(res=> {
                this.toastr.success('', res["message"], {
                  timeOut: 5000,
                  positionClass: 'toast-top-full-width',
                  progressBar: true
                  });
            }).catch(err =>{
              this.toastr.error("Please try again.", "There was a problem with creating new repair record", {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
            });
            console.log('creating repair...');
            
          }   

          this.uploadFile(this.prefixRepair, this.repair.file);
          this.getRepairs(this.myDropDown);  
          this.modalClose();
          this.refreshData.emit();   
          this.spinner = false; 
        }
      }
      else this.showInvalidDateToastr();
    }

    public formatDate(inDate: string) {
      let formatedDate: Date;
      formatedDate = new Date(inDate.replace(/-/g, "/"));
      return formatedDate;
    }

    openDeleteObjModal(obj, caller, modalName): void {
      if(obj){

        switch (caller){
          case this.prefixRepair:{ this.repair = obj; this.title = "Repair"; this.fileToDelete = obj.file; break}
          default: break;
        }
      }

      this.objToDelete = obj;
      this.modalRef = this.modal.open(modalName, { size: 'sm', backdrop: 'static'});
    }

    async deleteObj(objToDelete) {
      this.spinner = true;
      let caller;

      switch (this.title){
        case 'Repair' : {caller = this.prefixRepair;break;};
        default: {break;};
      }

        if(objToDelete.file != null && objToDelete.file != ''){
        this.deleteFile(caller, objToDelete.file);}
      
      switch(caller){
        
        case this.prefixRepair : {
          await this.maintenanceService.deleteRepair(objToDelete.id).toPromise().then(res => {
              this.toastr.success('', res["message"], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
                });
            
          }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with deleting the selected repair record", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          });
          break;
        }
        default: {break;};
      }
      this.getRepairs(this.myDropDown);
      this.modalRef.close();
      this.fileToDelete = '';  
      this.refreshData.emit();
      this.spinner = false;
    }

    public deleteFile(caller, filename){
      this.fileService.deleteFile(caller, filename).subscribe(result=>{console.log(result);})
        this.fileRemove = false;
        this.refreshData.emit();

    }

     print(elementId: string): void {
      let printContents, popupWin;
      printContents = document.getElementById(elementId).innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
        <head>
        <title>Maintenance - Repairs</title>
        <style>
        @page {
          size: A4;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          border: 1px solid #ddd !important;
      }

      th, td {
          text-align: left;
          padding: 16px;
      }


      tr:nth-child(even) {
          background-color: #f2f2f2 !important;
          box-shadow: inset 0 0 0 1000px #f2f2f2;
      }

      .fn {
        float: footnote;
      }

      thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
      }     
          
      </style>
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();
    }

    //file functions

     public getFile(event, caller){

      var imgFilename;

      if (event == '' || event == null){
        imgFilename = event
      }else{
        var file : ImageResult;
        file = event;
        imgFilename =  file.file.name;

        this.frmFile = event;
      }

      switch (caller){
        case this.prefixRepair: 
          { this.repairForm.controls.file.setValue(imgFilename); break;};
        default: break;
      }
    }

    public uploadFile(caller, filename){
      if (this.frmFile){
        this.fileService.uploadRawFile(caller, this.frmFile, filename).subscribe(file=>{
          console.log('file uploaded....');
        });
        
      }

      this.frmFile = '';

      //handling files if replaced, old file is removed from server
        if(this.fileRemove == true){
            this.deleteFile(caller, this.oldFile);
        };
    }

    public resetFileVariables(){
       // for document file handling variables; checking if file exists or removed
          this.fileExists = false;
          this.fileRemove  = false;
          this.oldFile = '';
    }

    public removeFile(caller){
      this.fileExists  = false;

      switch (caller){
      case  this.prefixRepair:
        { this.repairForm.controls.file.setValue(''); break;};
      default: break;
      }     
      this.fileRemove = true;
  }


  showFilters: boolean = false;
  
  filterRepairProvider: string = '';
  filterRepairRego: string = '';
  filterRepairDateFrom: Date;
  filterRepairDateTo: Date;

  isFilterEmpty: boolean = true;
  tempRepairs = [];
  
  fullRowsRepairs = [];
 
  repairCount = 0;
  
  public toggleFilters() {
    if (this.showFilters) this.showFilters = false;
    else this.showFilters = true;
  }

  updateFilter(caller) {
    this.isFilterEmpty = false;

    switch (caller){

      case this.prefixRepair :{

        this.tempRepairs = this.fullRowsRepairs.filter(data => {
         if (this.filterRepairProvider && data.provider_id){
            return data.provider_id == this.filterRepairProvider;    
          }else{
            return data.provider_id;
          }
        });

        this.tempRepairs = this.tempRepairs.filter(data => {
          if (this.filterRepairRego && data.rego){
            return data.rego.toLowerCase().indexOf(this.filterRepairRego.toLowerCase()) !== -1 || !this.filterRepairRego.toLowerCase();    
          }else{
            return data.rego;
          }
        });
        
        this.getRepairsFilterSummary(this.tempRepairs);
        this.computeRepairSubtotal();
        this.repair_rows = this.tempRepairs;
        this.repairCount = Object.keys(this.tempRepairs).length;

        if(this.repair_rows.length>0){
          this.selected = [this.repair_rows[0]]
        }else{
          this.selected = [];
        }      
      }
      this.totalRepairs = 0;
      this.averageRepairAmount = 0;
      this.totalRepairAmount = 0;

      if (this.repair_rows[0]) {
          let sum: number = this.repair_rows.map(a => a.cost).reduce(function(a, b)
          {
          return a + b;
          });
          this.totalRepairAmount = sum;
          this.totalRepairs = this.repair_rows.length;
      }

      this.averageRepairAmount = (this.totalRepairAmount / this.totalRepairs) || 0;
      default: {break;}
    }
  }

    public resetFilters() {
      this.filterRepairProvider = '';
      this.filterRepairDateFrom = null;
      this.filterRepairDateTo = null;
      this.filterRepairRego = '';

      this.repair_rows = this.fullRowsRepairs;

      if(this.repair_rows.length>0){
        this.selected = [this.repair_rows[0]]
      }else{
        this.selected = [];
      }
    
      this.isFilterEmpty = true;
      this.summaryCount = 0;
      this.summaryTotalCost = 0;
    }

  public modalClose() {
    this.fileExists = false;
    this.modalRef.close();
  } 


  public closeModal(){
    this.modalRef.close();
    this.modalCaller = null;
  }

  getCellClass({ row, column, value }): any {
    return {
      'is-pending': row.status_id == '1',
      'is-completed': row.status_id == '3',
      'is-processing': row.status_id == '2',
    };
  }

  toggleSideBar(){

    if(this.showSidebar== true){      
      this.loading_indicator4 = true;
      this.showSidebar = false;
      setTimeout(() => { this.loading_indicator4 = false; }, 100);

    }else{
      this.loading_indicator4 = true;
      this.showSidebar = true;
      setTimeout(() => { this.loading_indicator4 = false; }, 100);
    }
    this.getRepairs(this.myDropDown);

  }

  public getRepairsFilterSummary(tempRepairs){
    this.computeRepairSubtotal();
    this.summaryTotalCost = 0; this.summaryCount = 0;
    if(tempRepairs.length === this.fullRowsRepairs.length){
      this.summaryTotalCost = 0;
      this.summaryCount = 0;    
    } else {
      for(let i = 0; i < tempRepairs.length; i++){
        this.summaryTotalCost = this.summaryTotalCost + tempRepairs[i].cost;
      }
      this.summaryCount = tempRepairs.length;
    }
  }

  renameKey( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  generateHeaders(list_repairs): any{
    const arr = JSON.parse(list_repairs);
    arr.forEach( obj => {
      this.renameKey( obj, 'date_done', 'Date' );
      this.renameKey( obj, 'rego', 'Rego' );
      this.renameKey( obj, 'fleet_type', 'Fleet Type' );
      this.renameKey( obj, 'repair_description', 'Description' );
      this.renameKey( obj, 'provider', 'Provider' );
      this.renameKey( obj, 'cost', 'Cost' );
      this.renameKey( obj, 'receipt_no', 'Receipt No' );
      this.renameKey( obj, 'file', 'File' );}
    );
    const updatedJson = JSON.stringify( arr );
    return updatedJson;
  }

  repair_generateColumnsWithFilter(list_repairs){

    const arr = JSON.parse(JSON.stringify(list_repairs));
    arr.forEach( obj => {
      //Merge Fleet type and its subtype in the list
      obj['fleet_type'] =  obj['fleet_type'] + ' - ' + obj['subtype'];

      obj['date_done'] = formatDate(obj['date_done'], 'dd MMM yyyy', 'en_US');
      
      //remove filtered columns
      if(!this.showDate){
        delete obj['date_done'];
      };
      if(!this.showRego){
        delete obj['rego'];
      };
      if(!this.showFleetType){
        delete obj['fleet_type'];
      };
      if(!this.showDescription){
        delete obj['repair_description'];
      };
      if(!this.showProvider){
        delete obj['provider'];
      };
      if(!this.showCost){
        delete obj['cost'];
      };
      if(!this.showReceiptNo){
        delete obj['receipt_no'];
      };
      if(!this.showFile){
        delete obj['file'];
      };
      delete obj['id'];
      delete obj['fleet_id'];
      delete obj['provider_id'];
      delete obj['time_done'];
      delete obj['hours'];
      delete obj['driver_id'];
      delete obj['note'];
      delete obj['created_at'];
      delete obj['updated_at'];
      delete obj['hour'];
      delete obj['minute'];
      delete obj['incident_id'];
      delete obj['repair_request_id'];
      delete obj['fleet_report_id'];
      delete obj['mileage'];
      delete obj['fault'];
      delete obj['subtype']
      delete obj['driver_name'];
    });
    const updatedJson = JSON.stringify( arr );
    return updatedJson;
                                           
  }

  repair_exportToCSV(){
    if(this.repair_rows.length >0){
      console.log('exporting..');
      let with_header_format, with_column_filter;
      
      //generate json with filtered column
      with_column_filter = this.repair_generateColumnsWithFilter(this.repair_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let csv_file = '[TMS]Fleet_Maintenance_Repairs_' + this.formattedDate(current_date);
      this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Maintenance - Repairs');
    }
  };

  
  repair_exportToPDF(){
    if(this.repair_rows.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.repair_generateColumnsWithFilter(this.repair_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]Fleet_Maintenance_Repairs_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'REPAIRS';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };
  
  repair_exportToExcel(){
    if(this.repair_rows.length >0){
      let with_header_format, with_column_filter;
      
      //generate json with filtered column
      with_column_filter = this.repair_generateColumnsWithFilter(this.repair_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let excel_file = '[TMS]Fleet_Maintenance_Repairs_' + this.formattedDate(current_date);
      this.exp_excel.title = 'REPAIRS';
      this.exp_excel.type = 'xlsx';
      this.exp_excel.list_data = this.formatted_list;
      this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
        console.log(data);
        saveAs(data, excel_file)

      });
    }
  };

  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }
}